var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanPlat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 245,
    fill: "none",
    viewBox: "0 0 89 245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M.6 245h88.2V8.98A9 9 0 0 0 79.814 0H11.818c.027.063.057.135.09.218.67 1.657 3.136 7.751 32.211 36.132.538.525 1.21 1.128 1.979 1.817 7.38 6.618 23.577 21.14 13.108 49.616-11.489 31.25-4.041 39.605 4.806 49.531 5.004 5.615 10.457 11.733 13.182 22.781 7.544 30.58 9.285 63.679-33.075 58.282C10.232 214.06.986 234.327.6 245Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24.011,
    x2: -116.763,
    y1: -35.951,
    y2: 66.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF002B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#C61331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FF2A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF002B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanPlat);
export default __webpack_public_path__ + "static/media/plan_plat.850101d92fcebe163b490bdeaa5ce8b0.svg";
export { ForwardRef as ReactComponent };